<template>
    <el-dialog title="登录" :visible.sync="visible" class="login-dialog">
        <el-form :model="form" label-position="left" :rules="rules" ref="loginForm" hide-required-asterisk>
            <el-form-item label="用户名" label-width="100" prop="username">
              <el-input v-model="form.username" placeholder="请输入用户名" autocomplete="on"></el-input>
            </el-form-item>
            <el-form-item label="密码" label-width="100" prop="password">
              <el-input v-model="form.password"  show-password placeholder="请输入密码"></el-input>
            </el-form-item>
            <el-form-item label="验证码" label-width="100" prop="code">
              <Verify @error="alert('error')" :type="1" ref="verifyEle"></Verify>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="hideDialog" class="edit-dialog-btn">取 消</el-button>
            <el-button type="primary" @click="submitLogin" class="edit-dialog-btn edit-dialog-btn-confirm">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { login } from '@/api/login';
import { Message } from 'element-ui';
import Verify from '@/components/Verify/Verify.vue'
export default {
    props: ['isShow'],
    emit: ['upUser'],
    components: {
        Verify
    },
    data() {
        return {
            dialogshow: false,
            codeImg: '',
            code: '',
            form: {
                username: '',
                password: ''
            },
            rules: {
              username: [
                { required: true, message: '请输入用户名', trigger: 'blur' },
              ],
              password: [
                { required: true, message: '请输入密码', trigger: 'blur' },
              ],
              code: [
                { validator: this.checkCode, trigger: 'blur' }
              ],
            }
        }
    },
    created(){
    },
    mounted(){
    },
    computed: {
        visible: {
            get(){
                return this.isShow
            },
            set(){
                this.$emit("update:isShow", false)
            }
        }
    },
    methods: {
        checkCode(rule, value, callback){
            if(!this.$refs.verifyEle.checkCode()){
              return callback(new Error('验证码不正确'));
            }else{
              callback();
            }
        },
        hideDialog(){ 
            this.$emit("update:isShow", false)
        },
        submitLogin(){
          const _this = this;
          this.$refs.loginForm.validate((valid) => {
            if(valid){ 
              login(_this.form).then(res=>{
                if(res.errCode == 0){
                  const token = res.data;
                  localStorage.setItem('token', token);
                  let strings = token.split("."); 
                  var userinfo = JSON.parse(decodeURIComponent(escape(window.atob(strings[1].replace(/-/g, "+").replace(/_/g, "/")))));
                  localStorage.setItem('userNick', userinfo.userNick);
                  _this.$emit("upUser", userinfo.userNick);
                  Message.success({
                    message:'登录成功!'
                  });
                }else{
                  Message.error(res.errMessage);
                }
              })
              this.$emit("update:isShow", false)
            }else{
              return false;
            }
          })
        }
    }
}

</script>

<style lang="less" scoped>

.login-dialog{
    ::v-deep{
      .el-dialog{
        max-width: 600px;
      }
      .el-form-item__label{
        width: 106px;
        text-align: right;
      }
      .el-form-item__content{
        margin-left: 106px;
        margin-right: 32px;
      }
    }
  .dialog-footer{
    text-align: center;
    .edit-dialog-btn{
      width: 120px;
      height: 40px;
      border-radius: 30px;
      font-size: 18px;
      line-height: 40px;
      padding: 0;
    }
    .edit-dialog-btn:hover{
      color: #333;
      background: #fff;
      border-color: #DCDFE6;
    }
    .edit-dialog-btn-confirm{
      background: linear-gradient(144deg, #EF8B89 0%, #DA5351 100%);
      color: #FFFFFF;
      border: none;
    }
    .edit-dialog-btn-confirm:hover{
      background: linear-gradient(180deg, #DA5351 0%, #EF8B89 100%);
      color: #FFFFFF;
    }
  }
  .login-form-code-input{
    width: 80%;
  }
  .login-form-code{
    width: 18%;
    margin-left: 2%;
    height: 100%;
    vertical-align: bottom;
    cursor: pointer;
  }
}
//移动端
@media screen and (max-width: 960px) {
.login-dialog{
    ::v-deep{
      .el-dialog{
        font-size: .14rem;
        width: 90%;
      }
      .el-dialog__title{
        line-height: .24rem;
        font-size: .18rem;
      }
      .el-input__inner{
          height: 0.4rem;
          line-height: .4rem;
          padding: 0 .15rem;
          font-size: .14rem;
      }    
      .el-form-item__label{
        width: .7rem;
        font-size: .14rem;
        line-height: .4rem;
      }
      .el-form-item__content{
        margin-left: 0.7rem;
        margin-right: 0.32rem;
      }
    }
  .dialog-footer{
    .edit-dialog-btn{
      border-radius: .30rem;    
      font-size: .14rem;
      height: 0.4rem;
      line-height: .4rem;
      width: 1.2rem;
      padding: 0;
    }
  }
}
}
</style>